import React from 'react';
import './LandingFooter.css';
import LandingButton from '../LandingButton/LandingButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faMobileAlt, faRocket } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const handleWhatsAppContact = () => {
  const phoneNumber = '573163756770';
  const message = encodeURIComponent('¡Hola! Me gustaría más información sobre OviCatalogos');
  window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
};

function LandingFooter() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="ovicatalogos-footer">
      <div className="ovicatalogos-footer-gradient" />
      
      <div className="ovicatalogos-footer-container">
        <div className="ovicatalogos-footer-content">
          {/* Logo personalizado centrado */}
          <div className="ovicatalogos-footer-logo-section">
            <svg className="ovicatalogos-footer-logo-svg" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="ovi-footer-gradient-1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#4169E1" />
                  <stop offset="50%" stopColor="#8B5CF6" />
                  <stop offset="100%" stopColor="#10B981" />
                </linearGradient>
                <linearGradient id="ovi-footer-gradient-2" x1="100%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#06B6D4" />
                  <stop offset="100%" stopColor="#8B5CF6" />
                </linearGradient>
                <filter id="ovi-footer-glow">
                  <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                  <feMerge>
                    <feMergeNode in="coloredBlur"/>
                    <feMergeNode in="SourceGraphic"/>
                  </feMerge>
                </filter>
              </defs>
              
              <circle cx="100" cy="100" r="85" fill="none" stroke="url(#ovi-footer-gradient-1)" strokeWidth="6" opacity="0.3" />
              <circle cx="100" cy="100" r="70" fill="none" stroke="url(#ovi-footer-gradient-2)" strokeWidth="4" opacity="0.5" />
              
              <g filter="url(#ovi-footer-glow)">
                <path d="M 60 80 L 60 120 Q 60 130 70 130 L 95 130 L 95 70 L 70 70 Q 60 70 60 80 Z" 
                      fill="url(#ovi-footer-gradient-1)" />
                <path d="M 105 70 L 105 130 L 130 130 Q 140 130 140 120 L 140 80 Q 140 70 130 70 Z" 
                      fill="url(#ovi-footer-gradient-2)" />
                
                <line x1="68" y1="85" x2="87" y2="85" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="68" y1="95" x2="87" y2="95" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="68" y1="105" x2="87" y2="105" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="68" y1="115" x2="82" y2="115" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                
                <line x1="113" y1="85" x2="132" y2="85" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="113" y1="95" x2="132" y2="95" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="113" y1="105" x2="132" y2="105" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="118" y1="115" x2="132" y2="115" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                
                <line x1="100" y1="70" x2="100" y2="130" stroke="#ffffff" strokeWidth="2" opacity="0.3" />
              </g>
              
              <text x="100" y="108" fontSize="24" fontWeight="bold" fill="white" textAnchor="middle" opacity="0.9">O</text>
            </svg>
            <h3 className="ovicatalogos-footer-brand">OviCatalogos</h3>
          </div>
          
          <p className="ovicatalogos-footer-description">
            La solución definitiva para catálogos inteligentes que se actualizan automáticamente.
            <br />
            Perfecto para cualquier negocio que quiera vender más y mejor.
          </p>
          
          {/* Características destacadas */}
          <div className="ovicatalogos-footer-features">
            <div className="ovicatalogos-footer-feature">
              <FontAwesomeIcon icon={faBolt} className="ovicatalogos-footer-feature-icon" />
              <span>Actualización automática</span>
            </div>
            <div className="ovicatalogos-footer-feature">
              <FontAwesomeIcon icon={faMobileAlt} className="ovicatalogos-footer-feature-icon" />
              <span>Pedidos por WhatsApp</span>
            </div>
            <div className="ovicatalogos-footer-feature">
              <FontAwesomeIcon icon={faRocket} className="ovicatalogos-footer-feature-icon" />
              <span>Fácil de usar</span>
            </div>
          </div>
          
          <div className="ovicatalogos-footer-cta">
            <LandingButton
              variant="primary"
              size="lg"
              icon={faWhatsapp}
              onClick={handleWhatsAppContact}
            >
              Solicitar mi catálogo gratis
            </LandingButton>
          </div>
          
          <div className="ovicatalogos-footer-contact">
            <a 
              href="https://wa.me/573163756770"
              className="ovicatalogos-footer-contact-item"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="ovicatalogos-footer-contact-icon">
                <FontAwesomeIcon icon={faWhatsapp} />
              </div>
              <span>+57 316 375 6770</span>
            </a>
          </div>
        </div>

        <div className="ovicatalogos-footer-separator" />

        <div className="ovicatalogos-footer-bottom">
          <p className="ovicatalogos-footer-copyright">
            © {currentYear} OviCatalogos. Todos los derechos reservados.
          </p>
          <p className="ovicatalogos-footer-tagline">
            Diseñado para emprendedores que quieren vender más 🚀
          </p>
        </div>
      </div>
    </footer>
  );
}

export default LandingFooter;
